import { createTheme } from '@mui/material/styles';

const commonStyles = {
  padding: '12px 14px',
  borderRadius: '5px',
  fontWeight: 700,
  fontSize: '14px',
};

const theme = createTheme({
  typography: {
    fontFamily: '"Roboto", "Noto Sans KR", sans-serif',
    fontSize: 14,
    body1: {
      fontSize: '14px',
    },
    body2: {
      fontSize: '14px',
    },
    subtitle1: {
      fontSize: '14px',
    },
    subtitle2: {
      fontSize: '14px',
    },
    caption: {
      fontSize: '12px',
    },
    overline: {
      fontSize: '12px',
    },
    button: {
      fontSize: '14px',
    },
  },
  palette: {
    primary: {
      main: '#FF6F61', // Coral
    },
    secondary: {
      main: '#6B5B95', // Amethyst
    },
    background: {
      default: '#F7CAC9', // Rose Quartz
    },
    text: {
      primary: '#2E4A62', // Dark Blue
    },
    success: {
      main: '#4CAF50',
    },
    error: {
      main: '#F44336',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          ...commonStyles,
          borderRadius: '8px',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            borderRadius: '3px',
            fontSize: '14px',
          },
          '& .MuiInputBase-input': {
            padding: '12px 14px',
            fontSize: '14px',
            WebkitIMEMode: 'auto',
            IMEMode: 'auto',
          },
          '& .MuiInputLabel-root': {
            padding: '12px 14px',
            fontSize: '14px',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            borderRadius: '10px',
            fontSize: '14px',
          },
          '& .MuiInputBase-input': {
            padding: '12px 14px',
            fontSize: '14px',
          },
        },
        select: {
          fontSize: '14px',
        },
        icon: {
          fontSize: '14px',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '14px', // 원하는 폰트 크기
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 700,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '14px',
        },
      },
    },
  },
});

export default theme;
